<template>
	<div class="accountcenterPageWarp">
		<!-- <el-row>
			<el-col :span="18"> -->
		<div class="leftbox">
			<div class="topPanelBox">
				<div class="msgbox">
					<img :src='auditObj.logo?srcUrl+auditObj.logo:headImgUrl' class="headerImg" />
					<div class="username">{{auditObj.userName}}</div>
					<div class="companybox">{{auditObj.corpInfoName}}</div>
				</div>
				<!-- 天氣 -->
				<div class="weatherbox">
					<div id="he-plugin-standard"></div>
				</div>
				<div class="applybox" v-if="audit!=1" v-cloak>
					<img :src='bgimg1' class="bgimg1" />
					<img :src='icon1' class="iconimg" />
					<div class="textbox" @click="goapplyMember">申请入会</div>
					<div class="textbox2">欢迎加入中国人才交流协会</div>
				</div>
				<div v-else>
					<div class="evaluationbox" v-if="score" v-cloak>
						<img :src='bgimg2' class="bgimg2" />
						<div class="auditNamebox">{{evaluationObj.auditName}}</div>
						<img :src='icon2' class="iconimg" />
						<div class="scorebox">{{evaluationObj.score}}分</div>
						<div class="rate" v-if="evaluationObj.basicScoreLevel" v-cloak>：
							<span v-for="(value, i) in 5" :key="i" :class="{ active: i <= evaluationObj.basicScoreLevel - 1 }">A</span>
						</div>
						<div class="textbox2">{{auditObj.corpInfoName}}</div>
					</div>
					<div class="evaluationbox" v-else @click="goevaluFn">
						<img :src='bgimg2' class="bgimg2" />
						<img :src='icon2' class="iconimg" />
						<div class="textbox">欢迎测评</div>
						<div class="textbox2">人力资源服务能力指数</div>
					</div>
				</div>
				<!-- <div class="evaluationbox" v-else @click="goevaluFn">
							<div class="auditNamebox" v-if="evaluationObj">
								{{evaluationObj?evaluationObj.auditName:''}}
							</div>
							<img :src='bgimg2' class="bgimg2" />
							<img :src='icon2' class="iconimg" />
							<div class="textbox">欢迎测评</div>
							<div></div>
							<div class="textbox2">人力资源服务能力指数</div>
						</div> -->
			</div>
			<div class="listbox">
				<div class="infobox">
					<div class="msgheaderbox">
						<span class="title">消息通知</span>
						<div class="rightbox">
							<div class="filtimg1">
								<img src="@/assets/imgs/account/icon10.png" @click="filtrateDateFn" />
								<el-date-picker v-if="showfilter" v-cloak v-model="filtratevalue" type="daterange" align="right" unlink-panels range-separator="至"
								    start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions"
								    @change="selectTimeFn($event)">
								</el-date-picker>
								<!-- <img src="@/assets/imgs/account/icon10.png" v-else @click="filtrateDateFn" /> -->
							</div>
							<div @click="refreshFn">
								<img src="@/assets/imgs/account/icon11.png" />
							</div>
						</div>
					</div>
					<div class="databox" v-if='infoListData.length!=0' v-cloak>
						<!-- <div v-for="(item,index) in infoListData" :key="index" :class="'activeinfoitembox':'infoitembox'" @click='ckickInfoFn(index)'>
                        <div class="title">{{item.pressTopic}}</div>
                        <div class="date">{{item.pressTime | timer}}</div>
                        <div class="file">{{放啥}}</div>
                    </div> -->
						<div class="infoitembox" v-for="(item,index) in infoListData" :key="index">
							<!-- <div class="title overflowone">{{item.notificationContent}}</div> -->

							<!-- <div v-if="item.notificationContent"> -->
							<div class="title overflowone" v-if="item.notificationTitle&&item.notificationTitle.length>16">
								<el-popover trigger="hover" placement="top" width="468">
									<p>
										{{item.notificationTitle}}
									</p>
									<div slot="reference" class="overflowone" style="cursor: pointer;">
										{{item.notificationTitle}}
									</div>
								</el-popover>
							</div>
							<div class="title" v-else>
								{{item.notificationTitle}}
							</div>
							<div class="content overflowone" v-if="item.notificationContent&&item.notificationContent.length>15">
								<el-popover trigger="hover" placement="top" width="468">
									<p>
										{{item.notificationContent}}
									</p>
									<div slot="reference" class="overflowone" style="cursor: pointer;">
										{{item.notificationContent}}
									</div>
								</el-popover>
							</div>
							<div class="content" v-else>
								{{item.notificationContent}}
							</div>

							<div class="date">{{item.creationTime| timer}}</div>
							<div class="file" @click="downloadFile(item)">{{item.notificationfile}}</div>
							<!-- v-if="item.notificationType==2" -->
							<div class="goBox" @click="jumpMemberFn" v-if="item.notificationType==3">立即前往</div>
							<div class="goBox" @click="jumpLeadFn" v-if="item.notificationType==2">
								立即前往
							</div>
							<div class="goBox" @click="jumpGooseLeadFn" v-if="item.notificationType==4">
								立即前往
							</div>
						</div>

					</div>
					<div class="databox" v-else>
						<div class="emptyBox">
							<img src="@/assets/imgs/empty.jpg" />
						</div>
					</div>
				</div>

			</div>
		</div>
		<!-- </el-col>
			<el-col :span="5"> -->
		<div class="rightbox">
			<!-- 测评 -->
			<div class="evaluationbox" v-show="audit!=1" @click="goevaluFn" v-cloak>
				<img :src='bgimg2' class="bgimg2" />
				<img :src='icon2' class="iconimg" />
				<div class="textbox">欢迎测评</div>
				<div class="textbox2">人力资源服务能力指数</div>
			</div>
			<div class="loginlistbox">
				<div class="loginheaderbox">
					登录记录
				</div>
				<div>
					<el-table :data="tableData" style="width: 100%" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor">
						<el-table-column prop="operationContent" label="登陆方式">
						</el-table-column>
						<el-table-column prop="ip" label="设备名称">
						</el-table-column>
						<el-table-column label="登陆时间" align="center" width="120">
							<template slot-scope="scope">
								<div>
									{{scope.row.creationTime}}
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		<!-- </el-col>
		</el-row> -->
	</div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
export default {
	components: {
	},
	data() {
		return {
			srcUrl: srcUrl,
			headImgUrl: require("@/assets/imgs/account/header.png"),
			bgimg1: require("@/assets/imgs/account/bgimg1.png"),
			bgimg2: require("@/assets/imgs/account/bgimg2.png"),
			icon1: require("@/assets/imgs/account/icon7.png"),
			icon2: require("@/assets/imgs/account/icon8.png"),
			infoListData: [],
			activeindex: -1,
			tableData: [],
			currentPage: 1,
			// 每页显示条数
			pageSize: 10,
			// 总条数
			total: 0,
			// 筛选
			pickerOptions: {
				disabledDate: this.disabledDate,
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近三个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
					}
				}],			},
			filtratevalue: '',
			showfilter: false,
			auditObj: {},
			audit: 1,
			userId: '',
			userName: '',
			// 测评分数相关
			evaluationObj: null,
			score: '',
			token: sessionStorage.getItem('token'),
		}
	},
	created() {
		// 天气相关
		window.WIDGET = {
			"CONFIG": {
				"layout": "1",
				"width": "346",
				"height": "214",
				"background": "1",
				"dataColor": "FFFFFF",
				"borderRadius": "6",
				"key": "cfde930d2a8e47058dd57fab6143e95f"
			}
		}
		let script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = 'https://widget.qweather.net/standard/static/js/he-standard-common.js?v=2.0';
		document.getElementsByTagName('head')[0].appendChild(script);
		if (JSON.parse(sessionStorage.getItem('userInfo'))) {
			this.userId = JSON.parse(sessionStorage.getItem('userInfo')).userId
			this.userName = JSON.parse(sessionStorage.getItem('userInfo')).userName
		} else {
			this.userId = sessionStorage.getItem('nologinuserId')
		}
		// 会员状态
		if (this.token) {
			this.audit = sessionStorage.getItem('audit')
			this.getAuditFn()
		}
		// 测评
		this.evaluationFn()
	},
	mounted() {
		this.getinfofn()
	},
	methods: {
		// 测评
		async evaluationFn() {
			let data = await httpService.lookScoreFn(26);
			if (data.code == 200) {
				this.evaluationObj = data.result
				this.score = data.result.score
			}
		},
		getAuditFn() {
			httpService.getCorpInfoOther(this.userId).then(res => {
				// 99保存 0提交审核中 1通过 2审核失败
				if (res.code == 200) {
					this.auditObj = res.result
					this.audit = res.result.audit
					this.getLoginList()
				}
			})
		},

		async getinfofn() {
			let params = {
				pageSize: 100,
				pageCurrent: 1,
			};
			let data = await httpService.NotificationList(params);
			if (data.code == 200) {
				this.infoListData = data.result.list
			}
		},
		refreshFn() {
			this.filtratevalue = []
			this.showfilter = false
			this.getinfofn()
		},
		async selectTimeFn(e) {
			let params
			if (e) {
				params = {
					pageSize: 8,
					pageCurrent: 1,
					startTime: e[0],
					endTime: e[1]
				};
			} else {
				params = {
					pageSize: 8,
					pageCurrent: 1,
				};
			}
			let data = await httpService.NotificationList(params);
			if (data.code == 200) {
				this.infoListData = data.result.list
			}
		},
		ckickInfoFn(index) {
			this.activeindex = index
		},
		async getLoginList() {
			if (this.audit != 1) {
				this.pageSize = 8
			}
			let params = {
				pageSize: this.pageSize,
				pageCurrent: this.currentPage,
				userName: this.userName

			};
			let data = await httpService.getUserLog(params);
			if (data.code == 200) {
				this.tableData = data.result.list
			}
		},
		// 修改table tr行的背景色
		tableRowStyle({ row, rowIndex }) {
			return 'background-color: pink'
		},
		// 修改table header的背景色
		tableHeaderColor({ row, column, rowIndex, columnIndex }) {
			if (rowIndex === 0) {
				return 'background-color:#F7F7F7;color:#A6A9B7;font-size:16px;font-weight: 500;'
			}
		},
		goapplyMember() {
			this.$router.push('/account-center/member-ship');
		},
		// 日期筛选
		filtrateDateFn() {
			this.showfilter = !this.showfilter
		},
		disabledDate(time) {
			return time.getTime() > Date.now()
		},
		downloadFile(item) {
			let Docurl = `http:${
				process.env.VUE_APP_WZ
				}${"/upload/download?session="}${item.notificationfile}`;

			let a = document.createElement("a");
			document.body.appendChild(a);
			a.style.display = "none";
			a.setAttribute("download", "");
			a.setAttribute("target", "_self");
			a.setAttribute("href", Docurl);
			a.click();
			document.body.removeChild(a);
		},
		goevaluFn() {
			this.$router.push('/assessment-institutions');
		},
		// gonewsFn(item){
		// 	this.$router.push({
		// 		path: "/news-detail",
		// 		query: {
		// 			id: item.notificationId,
		// 		},
		// 	});
		// },
		jumpLeadFn() {
			this.$router.push({
				path: "/leade-talent",
				query: {
					source: 'account',
				},
			});
			sessionStorage.setItem('clickMenu', '培训服务')
		},
		jumpGooseLeadFn() {
			this.$router.push({
				path: "/lead-goose",
				query: {
					source: 'account',
				},
			});
			sessionStorage.setItem('clickMenu', '培训服务')
		},
		jumpMemberFn() {
			this.$router.push("/account-center/info-release");
		}
	},
	filters: {
		timer: (value) => {
			if (value) {
				return value.substring(0, 10);
			}
		},
	},
}
</script>
<style lang="less" scoped>
.accountcenterPageWarp {
  [v-cloak] {
    display: none !important;
  }
  width: 100%;
  height: 100%;
  padding-bottom: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  // overflow-y: scroll;
  // overflow-y: hidden;
  .topPanelBox {
    display: flex;
    flex-direction: row;
    height: 220px;
    margin-bottom: 30px;
    .msgbox {
      width: 346px;
      height: 214px;
      border: 1px solid #e8e8e8;
      box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.03);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-content: center;
      justify-content: center;
      align-items: center;
      .headerImg {
        width: 80px;
        height: 78px;
        border-radius: 50%;
      }
      .username {
        font-size: 20px;
        font-weight: bold;
        line-height: 31px;
        color: #43424b;
        margin: 9px 0 5px 0;
      }
      .companybox {
        font-size: 16px;
        color: #a6a9b7;
      }
    }
    .weatherbox {
      width: 346px;
      height: 214px;
      border-radius: 6px;
      margin: 0 22px 0 22px;
    }
    .applybox {
      width: 346px;
      height: 214px;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      // background: url(../../../assets/imgs/account/bgimg1.png);
      // background-size: 356px 214px;
      .bgimg1 {
        position: absolute;
        top: 0;
        left: -73px;
        z-index: -2;
      }
      .iconimg {
        width: 59px;
        height: 50px;
      }
      .textbox {
        font-size: 36px;
        font-weight: bold;
        line-height: 62px;
        color: #ffffff;
        cursor: pointer;
      }
      .textbox2 {
        font-size: 16px;
        line-height: 40px;
        color: #ffffff;
      }
    }
    .evaluationbox {
      width: 356px;
      height: 214px;
      border-radius: 6px;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 34px;
      .auditNamebox {
        position: absolute;
        left: 14px;
        top: 4px;
        color: #fff;
      }
      .scorebox {
        font-size: 34px;
        font-weight: bold;
        line-height: 50px;
        color: #ffffff;
      }
      .rate {
        position: relative;
        display: flex;
        align-items: center;
        font-size: 20px;
        line-height: 32px;
        color: #666666;
        span {
          color: #eee;
          font-weight: bold;
          font-size: 24px;
          margin-right: 5px;
          padding: 0 2px;
        }
        .active {
          color: #fadb14;
        }
      }
      .bgimg2 {
        position: absolute;
        top: 0;
        left: -75px;
        z-index: -2;
      }
      .iconimg {
        width: 47px;
        height: 55px;
      }
      .textbox {
        font-size: 36px;
        font-weight: bold;
        line-height: 62px;
        color: #ffffff;
        cursor: pointer;
      }
      .textbox2 {
        font-size: 16px;
        line-height: 40px;
        color: #ffffff;
      }
    }
  }
  .leftbox {
    max-width: 1120px;
  }
  .listbox {
    display: flex;
    flex-direction: row;
    // margin-top: 32px;
    .infobox {
      width: 1096px;
      height: 522px;
      border: 1px solid #e8e8e8;
      box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.03);
      border-radius: 10px;
      padding: 20px 0 0 0px;
      margin-right: 25px;
      box-sizing: border-box;
      .msgheaderbox {
        padding: 0 54px 10px 30px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .rightbox {
          display: flex;
          flex-direction: row;
        }
        .title {
          font-size: 24px;
          font-weight: bold;
          line-height: 24px;
          color: #43424b;
        }
        .filtimg1 {
          margin-right: 42px;
          display: flex;
          flex-direction: row;
          align-items: center;
          img {
            margin-right: 10px;
          }
        }
        img {
          cursor: pointer;
        }
      }
      .databox {
        width: 100%;
        height: 446px;
        overflow-y: auto;
        overflow-x: hidden;
        .activeinfoitembox {
          width: 1116px;
          height: 50px;
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 0 100px 0 30px;
          box-sizing: border-box;
          justify-content: space-between;
          background: rgba(0, 131, 255, 0.04);
          .title {
            width: 500px;
            font-size: 16px;
            color: #0083ff;
          }
          .date {
            cursor: pointer;
          }
          .file,
          date {
            font-size: 16px;
            color: #0083ff;
          }
          .file {
            cursor: pointer;
          }
        }
        .infoitembox {
          width: 1116px;
          height: 50px;
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 0 40px 0 30px;
          box-sizing: border-box;
          // justify-content: space-between;
          &:hover {
            background: rgba(0, 131, 255, 0.04);
            .title,
            .date,
            .file,
            .goBox {
              color: #0083ff;
            }
          }
          .title {
            width: 300px;
            font-size: 16px;
            color: #43424b;
            // cursor: pointer;
            text-align: center;
          }
          .content {
            width: 190px;
            text-align: center;
          }
          .date {
            width: 90px;
            font-size: 16px;
            color: #43424b;
            cursor: pointer;
            margin: 0 20px;
          }
          .file {
            font-size: 16px;
            color: #e3ac4f;
            cursor: pointer;
            width: 340px;
            // max-width: 340px;
            margin-right: 10px;
          }
          .goBox {
            font-size: 16px;
            color: #e3ac4f;
            cursor: pointer;
          }
        }
        .emptyBox {
          width: 198px;
          height: 200px;
          margin: 60px auto;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .databox::-webkit-scrollbar {
        width: 8px;
        /*height: 4px;*/
      }
      .databox::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
      }
      .databox::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
      }
    }
  }
  .rightbox {
    .evaluationbox {
      width: 356px;
      height: 214px;
      border-radius: 6px;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 34px;

      .bgimg2 {
        position: absolute;
        top: 0;
        left: -75px;
        z-index: -2;
      }
      .iconimg {
        width: 47px;
        height: 55px;
      }
      .textbox {
        font-size: 36px;
        font-weight: bold;
        line-height: 62px;
        color: #ffffff;
        cursor: pointer;
      }
      .textbox2 {
        font-size: 16px;
        line-height: 40px;
        color: #ffffff;
      }
    }
    .loginlistbox {
      width: 400px;
      // height: 653px;
      border: 1px solid #e8e8e8;
      border-bottom: none;
      box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.03);
      border-radius: 10px;
      padding: 20px 0 0 0px;
      box-sizing: border-box;
      overflow-y: auto;
      .loginheaderbox {
        padding: 0 54px 10px 30px;
        font-size: 24px;
        font-weight: bold;
        line-height: 24px;
        color: #43424b;
      }
      /deep/.el-table .el-table__cell {
        padding: 10px 0;
      }
    }
  }
}

// .accountcenterPageWarp::-webkit-scrollbar {
// 	// width: 8px;
// 	height: 4px;
// }
// .accountcenterPageWarp::-webkit-scrollbar-thumb {
// 	border-radius: 10px;
// 	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
// 	// background: rgba(0, 0, 0, 0.2);
// }
// .accountcenterPageWarp::-webkit-scrollbar-track {
// 	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
// 	border-radius: 0;
// 	background: rgba(0, 0, 0, 0.1);
// }
</style>


